export class PaginationRequest {
  page?: number;
  query?: any;
  sort?: string;
  pageSize?: number;

  constructor(query?: any, sort = "", page = 1, pageSize = 20) {
      this.page = page;
      this.query = query ? query : null;
      this.sort = sort ? sort.trim() : null;
      this.pageSize = pageSize;
  }
}
